<template>
  <ZDialog :show="isVisible" :modal-size="modalSize">
    <template #header>
      <div class="custom-header">
        <div class="row">
          <div class="col-md-11">
            <h4 class="modal-title">
              {{ title }}
            </h4>
          </div>
          <div class="col-md-1">
            <a href="#" @click="close" class="custom-close">
              <i class="fa fa-times"></i>
            </a>
          </div>
        </div>
      </div>
    </template>
    <template #body>
      <div class="hostWrapper">
        <VehicleSummary />
      </div>
    </template>
    <template #footer>
      <div class="custom-footer">
        <div class="row">
          <div v-if="isAdmin" class="col">
            <button type="button" class="btn btn-primary btn-sm" :disabled="isLoading" @click="decode()">
              <FontAwesomeIcon v-if="isLoading" icon="fa-solid fa-spinner" spin />
              <span :class="{ 'ms-1': isLoading }">Force Decode</span>
            </button>
          </div>
          <div class="col-1 text-right">
            <button type="button" class="btn btn-default" @click="close()">Close</button>
          </div>
        </div>
      </div>
    </template>
  </ZDialog>
</template>
<script>
import { mapActions, mapState } from 'pinia'
import { authStore } from '@/stores/auth'
import { buildStore } from '@/stores/build'
import VehicleSummary from '@/components/build/summary/VehicleSummary.vue'
import ZDialog from '@/components/utilities/elements/Dialog.vue'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
export default {
  name: 'DialogBuild',
  components: {
    VehicleSummary,
    ZDialog,
    FontAwesomeIcon
  },
  props: {
    modelValue: Object
  },
  data() {
    return {
      modalSize: 'modal-lg',
      isLoading: false
    }
  },
  mounted() {
    this.isLoading = false
  },
  computed: {
    ...mapState(authStore, ['profile']),
    ...mapState(buildStore, ['build']),
    isVisible() {
      return this.modelValue !== null
    },
    isAdmin() {
      let _is = false
      if (this.profile) {
        if ([1, 2].includes(this.profile.roles[0])) {
          _is = true
        }
      }
      return _is
    },
    title() {
      let _data = 'Build Summary'
      return _data
    }
  },
  methods: {
    ...mapActions(buildStore, ['forceDecode']),
    close() {
      this.$emit('closing')
    },
    async decode() {
      console.log('Force Decoding VIN:', this.build)
      if (this.build && this.build.vin) {
        this.isLoading = true
        await this.forceDecode(this.build.vin)
        this.isLoading = false
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.custom-header {
  width: 100%;
}

.custom-close {
  float: right;
  margin-right: 10px;
  color: #000;
  cursor: pointer;
}

.custom-footer {
  width: 100%;
}

.custom-right-align {
  text-align: right;
}

.hostWrapper {
  max-height: 750px;
  overflow-x: hidden;
  overflow-y: auto;
  height: 700px;
}
</style>
